import FormatJson from './src/formatJson.vue' // 导入组件

FormatJson.install  = app => app.component(FormatJson.name,FormatJson)

export default FormatJson

